import Highcharts from 'highcharts';

import COLORS from '../constants/colors';

export const globalChartConfig: Highcharts.Options = {
  chart: {
    spacing: [10, 0, 0, 0],

    style: {
      fontFamily: 'OpenSans, sans-serif',
    },
  },

  credits: {
    enabled: false,
  },
  xAxis: {
    labels: {
      style: {
        color: COLORS.auxiliarContent,
        fontSize: '13px',
        lineHeight: '16px',
      },
    },
    zoomEnabled: true,
  },

  yAxis: {
    gridLineColor: COLORS.lightLine,
    gridLineWidth: 0.7,
    gridLineDashStyle: 'ShortDash',
    title: {
      style: {
        color: COLORS.content,
        fontWeight: '600',
        fontSize: '13px',
        fontStyle: 'normal',
        lineHeight: '18px',
      },
    },
    labels: {
      style: {
        color: COLORS.auxiliarContent,
        fontSize: '13px',
        lineHeight: '16px',
      },
    },
  },

  legend: {
    itemStyle: {
      color: COLORS.content,
      fontWeight: '600',
      fontSize: '13px',
      fontStyle: 'normal',
      lineHeight: '18px',
    },
  },

  mapNavigation: {
    enableMouseWheelZoom: false,
  },
};

export const legendItems: Highcharts.LegendOptions = {
  align: 'left',
  x: 25,
  itemDistance: 10,
  itemMarginBottom: 12,
  symbolPadding: 8,
};
